import {
  DTODesignSystemComponentCreateInput,
  DTODesignSystemComponentListResponse,
  DTODesignSystemComponentResponse,
} from "../../../dto/design-systems/component";
import { RequestExecutor } from "../../../transport/request-executor";

export class DesignSystemComponentEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  async list(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/design-system-components`,
      DTODesignSystemComponentListResponse
    );
  }

  async create(dsId: string, vId: string, body: DTODesignSystemComponentCreateInput) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/design-system-components`,
      DTODesignSystemComponentResponse,
      {
        body,
        method: "POST",
      }
    );
  }
}
